/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import template from './layout-example-list-page.component.html';

import {ALL_LAYOUTS} from './examples/all-layouts';

@Component({
  standalone: false,
  selector: 'adn-layout-example-list-page',
  template
})
export class LayoutExampleListPageComponent {
  readonly allLayouts = ALL_LAYOUTS;
}
